import { useContext, useState } from 'react';
import { SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPencil, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { ThemeColorMode } from 'src/common/enums';
import { StyledDeleteIcon, StyledEditIcon, StyledSaveIcon, StyledTag, StyledTagActions, StyledTagCard, StyledTagHeader } from 'src/features/admin/tagging/tagging.styles';
import { TagForm } from 'src/features/admin/tagging/components/forms/tag-form-fields';
import { TagColourKey, TagColours, TagFormData, TagProps } from 'src/features/admin/tagging/tagging.types';
import { FormProvider, useForm } from 'src/common/form';
import { useTagFormResolver } from 'src/features/admin/tagging/hooks/use-tag-form-resolver';
export const TagCard = ({
  tag,
  tagCategories,
  handleDeleteTag,
  handleUpdateTag
}: TagProps) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkMode = theme === ThemeColorMode.DARK;
  const [editMode, setEditMode] = useState(false);
  const defaultValues = ({
    label: tag.label,
    colour: [tag.colour, TagColours[(tag.colour as TagColourKey)]],
    weight: tag.weight,
    category: {
      value: tag.category,
      label: ''
    },
    subcategory: tag.subcategory ? {
      value: tag.subcategory,
      label: ''
    } : null
  } as TagFormData);
  const form = useForm<TagFormData>({
    defaultValues,
    resolver: useTagFormResolver(defaultValues),
    mode: 'onChange'
  });
  const handleSave = () => {
    const values = form.getValues();
    handleUpdateTag({
      tagId: tag._id,
      body: {
        label: values.label,
        category: values.category.value,
        subcategory: values.subcategory?.value ?? null,
        colour: values.colour[0],
        weight: values.weight
      }
    });
  };
  return <StyledTagCard $isDark={isDarkMode} data-testid="tag-card" data-sentry-element="StyledTagCard" data-sentry-component="TagCard" data-sentry-source-file="tag-card.tsx">
      <StyledTagHeader data-sentry-element="StyledTagHeader" data-sentry-source-file="tag-card.tsx">
        <StyledTag data-testid="tag-label" $backgroundColor={TagColours[(tag.colour as TagColourKey)]?.backgroundColor} $fontColor={TagColours[(tag.colour as TagColourKey)]?.fontColor} $borderColor={TagColours[(tag.colour as TagColourKey)]?.borderColor} $isDisabled={false} data-sentry-element="StyledTag" data-sentry-source-file="tag-card.tsx">
          {tag.label}
        </StyledTag>
        <StyledTagActions data-sentry-element="StyledTagActions" data-sentry-source-file="tag-card.tsx">
          <StyledEditIcon aria-disabled={editMode} onClick={() => setEditMode(true)} $isDark={isDarkMode} data-testid="edit-icon" data-sentry-element="StyledEditIcon" data-sentry-source-file="tag-card.tsx">
            <FontAwesomeIcon icon={faPencil} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="tag-card.tsx" />
          </StyledEditIcon>
          <StyledSaveIcon aria-disabled={!editMode} onClick={() => {
          // eslint-disable-next-line no-void
          void form.handleSubmit(handleSave)();
          setEditMode(false);
        }} $isDark={isDarkMode} data-testid="save-icon" data-sentry-element="StyledSaveIcon" data-sentry-source-file="tag-card.tsx">
            <FontAwesomeIcon icon={faCheck} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="tag-card.tsx" />
          </StyledSaveIcon>
          <StyledDeleteIcon onClick={handleDeleteTag} $isDark={isDarkMode} data-testid="delete-icon" data-sentry-element="StyledDeleteIcon" data-sentry-source-file="tag-card.tsx">
            <FontAwesomeIcon icon={faTrashCan} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="tag-card.tsx" />
          </StyledDeleteIcon>
        </StyledTagActions>
      </StyledTagHeader>
      <FormProvider {...form} data-sentry-element="FormProvider" data-sentry-source-file="tag-card.tsx">
        <TagForm tagCategories={tagCategories} isCreating={false} existingTag={tag} fieldsDisabled={!editMode} isModal={false} data-sentry-element="TagForm" data-sentry-source-file="tag-card.tsx" />
      </FormProvider>
    </StyledTagCard>;
};